import {
    TextField
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import { useState } from 'react';

export default function DateWidget({ defaultValue, onChange }) {
    const [calDate, setCalDate] = useState(defaultValue);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
                value={dayjs(calDate || defaultValue)}
                onChange={(newValue) => {
                    setCalDate(newValue ? newValue.toDate() : null);
                    if (onChange) {
                        if(newValue === null) {
                            onChange(null);
                        } else {
                            onChange(newValue.toDate());
                        }
                    }
                }}
                inputFormat="YYYY-MM-DD"
                renderInput={(params) => <TextField {...params} size="small" sx={{ width: '160px' }} />}
            />
        </LocalizationProvider>
    )
}